import axios from 'axios';
import { BOOTSTRAP_APP } from '../events/types';
import { SET_SESSION, CLEAR_SESSION } from '../session/types';
import { setSession } from '../session/actions';
import LocalStorage from '../utils/storage';
import * as CognitoAuthService from '../services/CognitoAuthService';
import { baseApi } from '../services/api/baseApi';

const STORAGE_KEY_PREFIX = 'session_';

const sessionMiddleware =
  ({ dispatch, getState }) =>
    (next) =>
      (action) => {
        next(action);

        const session = getState().session.current;

        switch (action.type) {
          case BOOTSTRAP_APP: {
            const storedSession = loadSessionFromStorage(LocalStorage);
            if (storedSession) {
              dispatch(setSession(storedSession));
            }
            break;
          }
          case SET_SESSION:
            storeSessionInStorage(LocalStorage, action.payload);
            break;
          case CLEAR_SESSION:
            clearSessionFromStorage(LocalStorage);
            // Purge the RTK Query cache so the next user does not see the
            // previous tenant's data hydrate momentarily on login.
            dispatch(baseApi.util.resetApiState());
            // Wipe stale axios default headers so the next login cycle starts
            // clean. Without this, X-Tenant-Id from the previous session
            // leaks into the next user's bootstrap calls (get-workspaces).
            delete axios.defaults.headers.common['X-Tenant-Id'];
            delete axios.defaults.headers.common.Authorization;
            // Centralised logout: every CLEAR_SESSION (sidebar button, forced
            // logout on refresh failure, etc.) revokes the Cognito refresh
            // token server-side. Fire-and-forget — UI is already logged out
            // and a failed revoke shouldn't block. Guarded on
            // isCognitoConfigured so legacy/unconfigured envs don't throw.
            if (CognitoAuthService.isCognitoConfigured()) {
              CognitoAuthService.logout().catch(() => {});
            }
            break;
          default:
            if (!session) {
              const storedSession = loadSessionFromStorage(LocalStorage);
              if (storedSession) {
                dispatch(setSession(storedSession));
              }
            }
            break;
        }
      };

function loadSessionFromStorage(storage) {
  const key = `${STORAGE_KEY_PREFIX}current`;
  return storage.get(key, true);
}

function storeSessionInStorage(storage, session) {
  const key = `${STORAGE_KEY_PREFIX}current`;
  return storage.set(key, session, true);
}

function clearSessionFromStorage(storage) {
  const key = `${STORAGE_KEY_PREFIX}current`;
  storage.remove(key);
}

export default sessionMiddleware;
